import * as React from "react";
export const CancelIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={30} height={30} viewBox="0 0 30 30" {...props}>
      <g transform="translate(-8.062 -8.063)">
        <path
          d="M16.258,16.26a14.223,14.223,0,1,0,20.114,0A14.223,14.223,0,0,0,16.258,16.26Z"
          transform="translate(-3.254 -3.254)"
          fill="transparent"
        />
        <path
          d="M23.062,38.063a15.011,15.011,0,0,1-15-15,15.011,15.011,0,0,1,15-15,14.822,14.822,0,0,1,10.6,4.4h0a15,15,0,0,1-10.6,25.6Zm0-28.448a13.424,13.424,0,0,0-9.517,3.931,13.273,13.273,0,0,0-3.931,9.517,13.424,13.424,0,0,0,3.931,9.517,13.273,13.273,0,0,0,9.517,3.931A13.424,13.424,0,0,0,32.58,32.58a13.273,13.273,0,0,0,3.931-9.517,13.424,13.424,0,0,0-3.931-9.517h0A13.424,13.424,0,0,0,23.062,9.614Z"
          transform="translate(0)"
          fill="#01579B"
        />
        <path
          d="M69.19,68.1l2.927-2.927a.769.769,0,0,0-1.088-1.088L68.1,67.014l-2.927-2.953a.769.769,0,0,0-1.088,1.088L67.014,68.1l-2.953,2.927a.751.751,0,0,0,0,1.088.751.751,0,0,0,1.088,0L68.1,69.189l2.927,2.927a.751.751,0,0,0,1.088,0,.751.751,0,0,0,0-1.088Z"
          transform="translate(-45.039 -45.039)"
          fill="#01579B"
        />
      </g>
    </svg>
  );
};
